import * as React from 'react';

import { updateCartHeader, updateWishlistHeader } from '@notino/analyzer-tools';

import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { apiClientFactory } from '../../api';

import { IHairAnalyzerEvents } from './model';

export interface IHairAnalyzerEventProps {
  events: IHairAnalyzerEvents;
}

export const useHairAnalyzerEvents = (): IHairAnalyzerEventProps => {
  const {
    hairAnalyzer: { apiUrl },
  } = useApolloClientHeaders();
  const { addToCart, addToWishlist, removeFromWishlist } = React.useMemo(
    () =>
      apiClientFactory({
        apiUrl,
      }),
    [apiUrl]
  );

  const events = React.useMemo(() => {
    return {
      onAddToCart: async (products) => {
        await Promise.allSettled(
          products.map((product) => addToCart(product.id))
        );

        updateCartHeader();
      },
      onAddToFavorites: async (productId) => {
        await addToWishlist(productId);
        updateWishlistHeader();
      },
      onRemoveFromFavorites: async (productId) => {
        await removeFromWishlist(productId);
        updateWishlistHeader();
      },
      onCheckout: () =>
        window.location.assign(`${window.location.origin}/cart`),
      onClickProduct: (product) => window.location.assign(product.url),
      onExpandProduct: (_) => null,
    } as IHairAnalyzerEvents;
  }, [addToCart, addToWishlist, removeFromWishlist]);

  return { events };
};
